module.exports = __webpack_public_path__ + "img/انتزاعی.8d0acf02.png";